<template>
	<v-list-tile-content
		class="autocomplete-list-item">
		<div class="image-container">
			<v-img
				contain
				:height="30"
				:width="60"
				:src="loadImage(imageSrc)"
				@error="imageLoad_OnError"/>
		</div>
		<v-list-tile-title v-html="label"/>
	</v-list-tile-content>	
</template>


<script>
	export default {
		name: 'autocomplete-list-item',

		props: {
			imageSrc: {
				type: String,
				required: false,
				default: null
			},
			label: {
				type: String,
				required: true,
				default: ''
			}

		},

		data:() => ({
			imageLoadFailed: false
		}),

		computed: {
			loadImage() {
				return (img) => {
					let i = img.replace('large', 'small')
					return !this.imageLoadFailed ? i : require('@/assets/images/no-preview-available.jpg')
				}
			},
		},

		methods: {
			imageLoad_OnError() {
				this.imageLoadFailed = true
			}
		}
	}
</script>